import { render, staticRenderFns } from "./aWorkDetailEvent.vue?vue&type=template&id=b77fdcc2&scoped=true"
import script from "./aWorkDetailEvent.vue?vue&type=script&lang=js"
export * from "./aWorkDetailEvent.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailEvent.vue?vue&type=style&index=0&id=b77fdcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77fdcc2",
  null
  
)

export default component.exports